import { pick, prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import { useCallback, useRef } from 'react';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

const subscribe = (type) => {
    const api = window.Communication.API;

    dispatcher.dispatch(`${type}:loaded`);

    if (type === 'chat') {
        api.chat.onChatOpenWindow(() => {
            dispatcher.dispatch('chat:open');
        });
    } else if (type === 'inbox') {
        api.inbox.onOpenWindow(() => {
            dispatcher.dispatch('inbox:open');
        });

        api.inbox.onUpdateUnreadCount((count) => {
            dispatcher.dispatch('inbox:updateCounter', count);
        });
    }
};

const createContainer = (containerId, hideIcon) => {
    const container = document.createElement('div');

    container.id = containerId;

    if (hideIcon) {
        container.className = 'hide-icon';
    }

    document.body.appendChild(container);
};

export const useInit = () => {
    const { casinoName, clientType, clientVersion, inboxWidget, chatWidget } = useAppSelector(
        pick(['casinoName', 'clientType', 'clientVersion', 'inboxWidget', 'chatWidget']));
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    // avoid re-initialize after change language
    const langRef = useRef(useUserSelector(prop('lang')));

    return useCallback((type) => {
        const widgetConfig = type === 'inbox' ? inboxWidget : chatWidget;
        const containerId = `${type}Container`;
        const hideIcon = !widgetConfig.showLaunchIcon;
        const initParams = {
            selector: `#${containerId}`,
            casinoName,
            clientSkin: casinoName,
            clientType: clientType || 'casino',
            clientPlatform,
            clientVersion: clientVersion || '1.0',
            languageCode: langRef.current.slice(0, 2) || 'en',
            hideIcon,
            layout: widgetConfig.layout ?? {}
        };

        createContainer(containerId, hideIcon);
        subscribe(type);

        return window.Communication.API[type].init(initParams);
    }, [casinoName, clientType, clientVersion, langRef, chatWidget, inboxWidget, clientPlatform]);
};
